import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { CallbackSamlService } from './callback-saml.service';
import { first } from 'rxjs/operators';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-callback-saml',
  templateUrl: './callback-saml.component.html',
  styleUrls: ['./callback-saml.component.scss']
})
export class CallbackSamlComponent implements OnInit {
  routeParam$: Subscription;

  userData: string;
  message: string;

  constructor(private route: ActivatedRoute,
    private router: Router,
    private callbackSamlService: CallbackSamlService) {
     }

  ngOnInit(): void {
    document.cookie = 'JSESSIONID=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    document.cookie = 'JSESSIONID=; Path=/api/authentication; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    //console.log('callback-saml.component - init - cookie: ', document.cookie);
    this.routeParam$ = this.route.queryParams.subscribe(params => {
      //console.log('callback-saml.component - init - params:', params);
      this.userData = params['token'];
      this.callbackToken(params['token'])
    });
    
  }

  callbackToken(token : string) {
    //console.log('callback-saml.component - callbackToken - token:' + token);
    if (token) {
      if (this.callbackSamlService.callbackToken(token)) {
        this.router.navigate(['/']);
      } else {
        this.message = 'Se ha producido un error iniciando sesión con la información suministrada.';
      }
    } else {
      this.message = 'Error. El usuario con el que se intenta iniciar sesión no se encuentra dado de alta en la aplicación.';
    } 
  }

}
